import StyleSheetRW from "core/StyleSheetRW";
import { rh } from "core/designHelpers";
const styles = StyleSheetRW.create(() => ({
    dummy:{ width: 20, height: 24, marginTop: 20 },
    secondaryImage:{ marginTop: 20, height: 200, width: 200, borderRadius: 100 },
    image:{ marginTop: 20, height: 150, width: 150, borderRadius: 100 },
    userView:{ fontWeight: '700', fontSize: 36, color: '#2F4858',  textAlign: 'center', marginTop: 10, width: "200px", wordBreak:"break-word" },
    userViewMobile:{ fontWeight: '700', fontSize: 36, color: '#2F4858',  textAlign: 'center', marginTop:10, width: "200px", wordBreak:"break-word" },
    general:{ display: 'flex', flexDirection: 'column', alignItems: 'center',marginTop:10 },
    generalMobile:{ display: 'flex', flexDirection: 'column', alignItems: 'center',marginTop:5 },
    icon:{ width: 13.89, height: 24, marginTop: 20 },
    topBar:{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between'},
    outer:{ display: 'flex', flexDirection: 'row', height: '100%', justifyContent: "center" },
    heading: { fontWeight: '700', fontSize: 36, color: '#2F4858', marginTop: 20 },
    timerContainer: { width: '100%', backgroundColor: '#e8f0eb', display: 'flex', borderRadius: 16, alignItems: 'center', justifyContent: 'space-between', marginTop: '8px', gap: '9px' },
    timeText: { fontSize: 36, fontWeight: '500' },
    tableHeading: { fontSize: 20, fontWeight: 'bold', marginBottom: '10px' },
    tableHead: { padding: '8px', textAlign: 'left', borderBottom: '1px solid #2F4858', fontWeight: '300' },
    tableStyle: { width: "100%", borderCollapse: 'collapse', backgroundColor: '#FFFFFF66' },
    tableData1: { padding: '8px', borderLeft: '1px solid #2F485880' },
    body: { width: "100%", height: "100%", alignItems: "center", marginTop: rh(35) },
  }))
  
export default styles;